var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceyourcursorStartspeakingwithZeroTypingapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9797 8.0041C15.9797 3.60195 12.4001 0.0209961 7.99961 0.0209961C3.59913 0.0209961 0.0195312 3.60195 0.0195312 8.0041C0.0195312 12.4062 3.59913 15.9872 7.99961 15.9872C12.4001 15.9881 15.9797 12.4062 15.9797 8.0041ZM7.99961 12.9669C5.26442 12.9669 3.03867 10.7404 3.03867 8.0041C3.03867 5.26781 5.26435 3.04128 7.99961 3.04128C10.7349 3.04128 12.9605 5.26781 12.9605 8.0041C12.9605 10.7404 10.7349 12.9669 7.99961 12.9669Z",
    fill: "#14AA51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.098 8.0041C12.098 10.2679 10.2627 12.104 7.99961 12.104C5.73657 12.104 3.90125 10.268 3.90125 8.0041C3.90125 5.7402 5.73657 3.90419 7.99961 3.90419C10.2627 3.90419 12.098 5.7402 12.098 8.0041Z",
    fill: "#14AA51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceyourcursorStartspeakingwithZeroTypingapp);
export default __webpack_public_path__ + "static/media/Place your cursor & Start speaking with Zero Typing app.f9c96b983689c5c1a69241e85aef89ee.svg";
export { ForwardRef as ReactComponent };